import api from "@/config/api";

const path = "public/formular/employee/personaccidentreport"

export default {

  get: (token) => {
    return api.get(`${path}/${token}`)
  },
  post: (personaccidentreport, token, abschliessen = false) => {
    return api.post(path, personaccidentreport, { params: { token, abschliessen } })
  }
}
